const memoryObj = {};

export const memoryStorage = {
  getItem: key => {
    return memoryObj[key] || null;
  },
  setItem: (key, value) => {
    memoryObj[key] = value;
  }
};
